import { Button, Stack, Typography } from '@mui/material';
import MainCard from '../berry/ui-component/cards/MainCard.jsx';
import CONFIG from '../config.json';

export default function Backup() {
	const handle_download_data_zip = () => {
		const a = document.createElement('a');
		a.href = `${CONFIG.api}/app_data/data.zip`;
		a.target = '_blank';
		a.rel = 'noopener noreferrer';
		a.click();
	};

	return (
		<MainCard title="Backup">
			<Stack spacing={2}>
				<Typography color="textSecondary">Download current generated backup archive.</Typography>
				<Button variant="outlined" onClick={handle_download_data_zip}>Download data.zip</Button>
			</Stack>
		</MainCard>
	);
}
